import React, { useEffect } from 'react';
import { ErrorMessages } from '../../types/ErrorTypes';
import { scrollIntoView, scrollTop } from '@utils';

interface ErrorSummaryProps {
  title?: string;
  messages: ErrorMessages[] | undefined;
}

export const ErrorSummary: React.FC<ErrorSummaryProps> = ({
  messages,
  title = 'There is a problem',
}) => {
  const noErrorBool =
    !messages ||
    messages.length === 0 ||
    messages.every((item) => !item.message);

  useEffect(() => {
    if (noErrorBool) {
      return;
    }
    scrollTop();
  }, [messages]);
  /**
   * return null if there are no messages, or all messages are empty
   */
  if (noErrorBool) {
    return null;
  }

  return (
    <div
      id="error-summary"
      data-testid="error-summary"
      className="max-w-form p-inset border-sm text-status-error mt-4 w-full rounded border-current"
      role="alert"
    >
      <h2 className="text-h4 text-text-dark mb-2">{title}</h2>
      <ul className="text-body flex flex-col gap-1">
        {messages &&
          messages.map((message) => (
            <li
              key={message.path}
              className="cursor-pointer text-inherit underline underline-offset-2 outline-offset-2 outline-inherit hover:decoration-auto"
            >
              <a
                onClick={() => scrollIntoView(message.path)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    scrollIntoView(message.path);
                  }
                }}
                tabIndex={0}
              >
                {message.message}
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
};
